// extracted by mini-css-extract-plugin
module.exports = {"lang":"kD","langWrap":"kE","item":"kF","itemCurrent":"kG"};